var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { FieldType, Input, Select, View } from '../elements';
import { T } from '../helpers/i18n';
import { TypeDiscount } from '../modules/DiscountReasons/IDiscount';
import { toRound } from '../helpers/Format';
import theme from '../Theme';
import { observer } from 'mobx-react';
let DiscountView = class DiscountView extends Component {
    render() {
        const { height, tempSale, colorTextDiscount, colorTextTotalDiscount, moneyName, options, typeDiscount, busy, textBorded, errorTotal, onChangeSelect, onHandleInputDiscount } = this.props;
        const optionsSelect = options || Object.entries(TypeDiscount).map(item => ({ name: T(item[1]), value: item[1] }));
        return (React.createElement(View, null,
            React.createElement(View, { flex: true, row: true, center: true, style: {
                    height: height - 5,
                    marginLeft: 0,
                    marginRight: 0
                } },
                React.createElement(Select, { style: { width: 80, marginLeft: 10 }, label: T('type'), onChange: event => {
                        onChangeSelect(event.currentTarget.value);
                    }, value: typeDiscount, options: optionsSelect }),
                React.createElement("div", { style: {
                        // flex: 10,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        paddingLeft: 10
                    } },
                    React.createElement("p", { style: {
                            marginRight: '10px',
                            marginTop: 0,
                            marginBottom: 0,
                            textAlign: 'left',
                            // flex: 1,
                            fontWeight: 500,
                            color: colorTextDiscount
                        } }, `${T('discount')}`)),
                typeDiscount === TypeDiscount.Percentage &&
                    React.createElement("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'flex-start'
                        } },
                        React.createElement("p", { style: {
                                marginTop: 0,
                                marginBottom: 0,
                                marginRight: '10px',
                                fontWeight: 'bold',
                                color: colorTextTotalDiscount
                            } }, `${tempSale.totalDiscount > 0 ? toRound(tempSale.totalDiscount) : ''} ${tempSale.totalDiscount > 0 ? moneyName : ''}`)),
                React.createElement(View, { style: {
                        flex: 6,
                        alignContent: 'center',
                        justifyContent: 'center',
                        alignItems: 'center'
                    } },
                    React.createElement(View, { flex: true, row: true, style: {
                            justifyContent: 'center',
                            flex: 10
                        } },
                        React.createElement(Input, { type: FieldType.Text, value: tempSale.discount > 0 ? tempSale.discount.toString() : '', onChange: onHandleInputDiscount, style: {
                                justifyContent: 'center',
                                padding: '5px',
                                marginTop: 0,
                                marginBottom: 0,
                                width: '80px',
                                textAlign: 'right',
                                color: tempSale.totalDiscount > 0 ? tempSale.totalDiscount > tempSale.totalWithoutDiscount ? theme.color.primary : theme.color.primary : theme.color.secondary
                            }, onFocus: () => {
                                console.log('TextInput onFocus');
                            } }),
                        React.createElement("p", { style: {
                                textAlign: 'center',
                                marginTop: '5px',
                                marginBottom: 0,
                                marginRight: 20,
                                fontWeight: 'bold',
                                color: tempSale.totalDiscount > 0 ? tempSale.totalDiscount > tempSale.totalWithoutDiscount ? theme.color.primary : theme.color.primary : theme.color.secondary
                            } }, typeDiscount === TypeDiscount.Fix ? ` ${moneyName}` : '%')))),
            tempSale.totalDiscount > tempSale.totalWithoutDiscount && React.createElement("p", { style: {
                    flex: 1,
                    fontSize: 10,
                    color: tempSale.totalDiscount > 0 ? tempSale.totalDiscount > tempSale.totalWithoutDiscount ? theme.color.primary : theme.color.primary : theme.color.secondary
                } }, 'El descuento es mayor que el precio a pagar')));
    }
};
DiscountView = __decorate([
    observer
], DiscountView);
export default DiscountView;



//////////////////
// WEBPACK FOOTER
// ./src/components/DiscountView.tsx
// module id = 559
// module chunks = 0